
















































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace, Getter, State, Mutation } from "vuex-class";
import moment from "moment";
import { cloneDeep } from "lodash";

import vSelect from "vue-select";

import ExtendTimer from "@/components/dispatch/ExtendTimer.vue";

import {
	axiosJsonInstance
} from "@/axios.instance";

import { get } from "lodash";
import { DispatchRequest, MobileFeatures } from "@/store/mobile/types";
import { AlarmQueueFilterID, AlarmQueueFilter } from "@/store/eventqueue/types";
import { UserPermissions } from "@/store/types";

import api from "@/services/api.service";
import mobileApi from "@/services/api.mobile.service";

import {
	Guard,
	GuardTour,
	DispatchableEvent,
	MapOptions,
	DispatchStatus,
	GuardsByStatus,
	EventStatus,

	MapFilter,
	DispatchMap,
	Sidebar,
	GuardList,
	ToursList,
	GuardDispatchQueue,

	DispatchApi,
	DispatchUpdateService
} from "@sureview/v2-dispatch";

import {
	ILatLng
} from "@sureview/v2-mapping";

import DispatchGuardDetails from "./GuardDetails.vue";

const Mobile = namespace("mobile");

const dispatchApi = new DispatchApi(axiosJsonInstance);

@Component({
	components: {
		"v-select": vSelect,
		"dispatch-guard-details": DispatchGuardDetails,
		"extend-timer": ExtendTimer
	}
})
export default class MobileGuardList extends Vue {
	$refs: {
		extendTimer: ExtendTimer
	}

	@State("User") currentUser: {
		userId: number,
		fullName: string;
	};

	// Feature flag
	@Mobile.Getter("getMobileFeatures") getMobileFeatures: MobileFeatures;
	@Getter("getFeature") getFeature: (featureName: string[]) => boolean;
	@Getter getPermissions: UserPermissions;

	@Mobile.State("ManageGuards") guards: Guard[];
	@Mobile.State("ManageEvents") alarms: DispatchableEvent[];
	@Mobile.State("ManageAlarmQueueFilters") public alarmQueueFilters: AlarmQueueFilter[];
	@Mobile.State("ManageCurrentAlarmQueueFilters") public currentFilters: AlarmQueueFilter[];
	@Mobile.State("MapGoto") public mapGoto: (latLng: ILatLng) => void

	@Mobile.Mutation("setManageCurrentFilters") setCurrentFilters: (filters: AlarmQueueFilter[]) => void;

	guardExpanded: { [guardId: number]: boolean } = {};

	get currentAlarmQueueFilters(): AlarmQueueFilter[]
	{
		return this.currentFilters;
	}
	set currentAlarmQueueFilters(value: AlarmQueueFilter[])
	{
		this.setCurrentFilters(value);
	}

	public get isDispatchEnabled() {
		return this.getFeature(["Dispatch"]) && this.getFeature(["Mobile", "ManageDispatch"]);
	}

	get userCanCancelDispatch() {
		return this.getPermissions["canCancelDispatch"];
	}

	dispatchGuardToAlarm ({ guard, event, latLong }: { guard: Guard, event: DispatchableEvent, latLong: string }) {
		mobileApi.addDispatchRequest(guard.guardId, null, event.eventId,
			this.currentUser.fullName, "Dispatch to area and investigate", latLong, "");
	}

	async clearGuardStatus (guard: Guard) {
		if (guard.status === DispatchStatus.OnBreak) {
			await dispatchApi.guardMakeAvailable(guard.guardId);
		} else {
			const queue = await dispatchApi.dispatchQueue(guard.guardId);
			const activeEvent = queue.find(q => q.active);
			if (activeEvent) {
				dispatchApi.dispatchFinish({
					guardId: guard.guardId,
					dispatchQueueId: activeEvent.dispatchQueueID
				});
			}
		}
	}

	toggleExpanded(guardId: number) {
		Vue.set(this.guardExpanded, guardId, !this.guardExpanded[guardId]);
	}

	patrolZonesText(patrolZones: any): string {
		return Object.keys(patrolZones).map(k => patrolZones[Number(k)]).join(", ");
	}

	gotoLocation(location: ILatLng) {
		if (this.mapGoto) {
			this.mapGoto(location);
		}
	}
}
